import { IBreadcrumbProps, ISearchBoxStyles, SearchBox } from "@fluentui/react";
import { New16Regular } from "@fluentui/react-icons";
import { Paper } from "@mui/material";
import { ChangeEvent, CSSProperties, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FEATURE_REQUEST_SEARCH_STYLES } from "../components/FeatureRequestSearch/FeatureRequestSearch.styles";
import FeatureRequestDataGrid from "../components/FeatureRequestSearch/FeatureRequestSearchGridComponent";
import { logPageView } from "../helper/AppInsightsHelper";
import { CustomBreadcrumb } from "../SharedComponents/CustomBreadcrumb";
import { debounce } from "../Utils/js-common";

const style = {
  searchBoxParent: {
    marginBottom: 18
  } as CSSProperties,
  seachBox: {
    root: {
      width: "60%",
      marginLeft: "20%",
      marginTop: 3,
      borderRadius: 4
    }
  } as Partial<ISearchBoxStyles>
};
const breadcrumbStyles = {
  root: {
    fontSize: "14px",
    margin: 0,
    "--itemLink-color": "rgb(0, 120, 212)"
  },
  item: {
    fontSize: "inherit"
  },
  itemLink: {
    fontSize: "inherit",
    color: "var(--itemLink-color)",
    ":hover": {
      background: "none",
      textDecoration: "underline",
      color: "var(--itemLink-color)"
    }
  }
};

export default function FeatureRequestSearch() {
  const navigate = useNavigate();
  const key = "feature-request-search-bc";
  const [searchText, setSearchText] = useState("");
  const bcrops: IBreadcrumbProps = {
    items: [
      { text: "Home", key: "home", onClick: () => navigate("/") },
      { text: "Explore Feature Requests", key: "explore-feature-requests", isCurrentItem: true }
    ],
    styles: breadcrumbStyles
  };

  // Search function
  const performSearch = (query: string) => setSearchText(query);

  // Debounced search function
  const debouncedSearch = debounce(performSearch);

  const onChange = (event?: ChangeEvent<HTMLInputElement>) => debouncedSearch(event?.target.value ?? "");

  const onClear = (event?: any) => performSearch(event?.target.value || "");

  useEffect(() => logPageView("Feature Request Search Page", window.location.href), []);

  return (
    <div className="mainCard" style={{ marginRight: 10 }}>
      <div style={{ display: "flex", width: "100%", justifyContent: "space-between" }}>
        <CustomBreadcrumb {...bcrops} key={key} />
        <div
          style={{
            marginTop: "10px",
            marginRight: "16px",
            marginBottom: "10px",
            backgroundColor: "#0078D4",
            color: "#FFFFFF",
            padding: "4px 12px",
            borderRadius: "9999px",
            display: "inline-flex",
            alignItems: "center",
            fontSize: "12px",
            fontWeight: 500
          }}
        >
          <New16Regular fontSize={12} style={{ marginRight: 4 }} />
          <span>Beta</span>
        </div>
      </div>
      <Paper className={FEATURE_REQUEST_SEARCH_STYLES.FEATURE_REQUEST_SEARCH_DATA_GRID.CLASS_NAMES.GRID_AND_FILTER_PILL_CONTAINER}>
        <div style={style.searchBoxParent}>
          <SearchBox
            disableAnimation
            onChange={onChange}
            onClear={onClear}
            onSearch={performSearch}
            placeholder="Search Feature Request by FeatureRequestId, UnifiedFeatureRequestId, Title, Description"
            styles={style.seachBox}
          />
        </div>
        <FeatureRequestDataGrid searchText={searchText} />
      </Paper>
    </div>
  );
}
